/**
 * Created by Kamil on 24.05.2017.
 */

import React, {Component} from 'react';
import openFolder from '../open-folder.svg';
import folder from '../folder.svg';
import './FilterLink.css';

class FilterLink extends Component {
    constructor(props) {
        super(props);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.state = {id: this.props.id}
    }

    handleFilterChange() {
        this.props.changeFilter(this.state.id);
    }

    render() {
        return (
            <a onClick={this.handleFilterChange} className={'FilterLink ' + (this.props.active ? 'FilterLink-active' : 'FilterLink-inactive')}>
                <img src={this.props.active ? (window.viewDir + openFolder) : (window.viewDir + folder)}/>
                {this.props.name}
            </a>
        );
    }
}

export default FilterLink;


// WEBPACK FOOTER //
// ./src/components/FilterLink.js